import { render, staticRenderFns } from "./GameLogo.vue?vue&type=template&id=5d1c2b5b&scoped=true&"
import script from "./GameLogo.vue?vue&type=script&lang=js&"
export * from "./GameLogo.vue?vue&type=script&lang=js&"
import style0 from "./GameLogo.vue?vue&type=style&index=0&id=5d1c2b5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1c2b5b",
  null
  
)

export default component.exports